import React, { useEffect } from "react";
import ReactDragList from "react-drag-list";
import { connect } from "react-redux";
import QuestionModal from "./Question/QuestionModal";
import { questionActions } from "../../../../../store/actions/question/question.action";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { Tooltip, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Avatar, makeStyles, InputBase, IconButton } from "@material-ui/core";

import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import BarChartIcon from "@material-ui/icons/BarChart";
import SubjectIcon from "@material-ui/icons/Subject";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import SortIcon from "@material-ui/icons/Sort";
import { SmallLoader } from "../../../../../digitalArena/utils/ClientConnectionFallback";
import { useState } from "react";
const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    backgroundColor: "#3a3b3c",
    borderRadius: 5,
    marginRight: theme.spacing(2),
    marginLeft: 10,
    marginRight: 10,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginLeft: 10,
      marginRight: 10,
      width: "100%",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    color: "#FFFFFF99",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "#FFFFFF99",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  online: {
    background: "#44b700",
  },
  offline: {
    background: "orangered",
  },
}));

export function QuestionList(props) {
  const [filter, setFilter] = useState("");
  const [modalOpen, toggleModal] = useState(false);
  const [unlocked, setUnlocked] = useState(false);
  const [hasChanged, setChanged] = useState(false);
  const [questionDeployLoadingId, setQuestionDeployLoadingId] = useState(null);
  const [modifiedQuestions, setQuestions] = React.useState(props.questions ? Array.from(props.questions) : null);

  useEffect(() => {
    if (questionDeployLoadingId == props.activePresenterQuestion) setQuestionDeployLoadingId(null);
  }, [props.activePresenterQuestion]);
  const sortQuestions = (questions) => {
    if (!questions || questions.length === 0) return [];
    questions.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
    return questions;
  };
  const onUnlock = (val) => {
    if (val === true) setQuestions(props.questions);

    setUnlocked(val);
  };
  const save = () => {
    const newQuestions = Array.from(modifiedQuestions);
    newQuestions.map((q, i) => {
      q.sortOrder = i;
    });

    props.dispatch(questionActions.updateQuestions(newQuestions));
    props.updateQuestions(newQuestions);
    setChanged(false);
  };
  const handleOrderChange = (event, dataSource) => {
    const sortedQuestions = dataSource.map((ds, i) => {
      let el = Object.assign({}, ds);
      el.sortOrder = i;
      return el;
    });
    setQuestions(sortedQuestions);
    setChanged(true);
  };
  const classes = useStyles();
  const renderTypeIcon = (type) => {
    switch (type) {
      case "Text":
        return (
          <Avatar style={{ backgroundColor: "#56af55" }}>
            <SubjectIcon />
          </Avatar>
        );
      case "Option":
        return (
          <Avatar style={{ backgroundColor: "#dc8b4d" }}>
            <CheckBoxIcon />
          </Avatar>
        );
      default:
        break;
    }
  };
  const searchFilter = (e) => {
    setFilter(e.target.value);
  };

  const addQuestion = () => {
    toggleModal(!modalOpen);
  };
  const getMaxSortOrder = () => {
    let max = 0;
    if (props.questions.length > 0) {
      max =
        Math.max.apply(
          null,
          props.questions.map((q) => {
            return q.sortOrder;
          })
        ) + 1;
    }
    return max;
  };

  const renderQuestionList = () => {
    const { questions, user, activeQuestions, activePresenterQuestion, deployQuestionToClients, deployQuestionToPresenter, toggleQuestionInfo, selectedQuestion, questionTagList = [] } = props;
    if (questions === undefined) return null;
    if (!modifiedQuestions) setQuestions(questions);
    const questionItems = unlocked ? sortQuestions(modifiedQuestions) : sortQuestions(questions);
    return (
      <div style={{ marginTop: 10, overflowX: "hidden" }}>
        <div style={{ width: "100%", display: "inline-flex" }}>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              onInput={searchFilter}
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
            />
          </div>
          {!unlocked ? (
            <IconButton onClick={() => addQuestion()} edge="start" style={{ padding: "0px 10px", color: "#ffffff99" }}>
              <AddIcon />
            </IconButton>
          ) : null}
          <IconButton
            onClick={() => onUnlock(!unlocked)}
            edge="start"
            style={{
              padding: "0px 10px",
              color: unlocked ? "#fff" : "#ffffff99",
            }}
          >
            <SortIcon />
          </IconButton>
          {unlocked ? (
            <IconButton
              onClick={save}
              disabled={!hasChanged}
              edge="start"
              style={{
                padding: "0px 10px",
                color: !hasChanged ? "rgba(255, 255, 255, 0.28)" : "#fff",
              }}
            >
              <SaveIcon />
            </IconButton>
          ) : null}
        </div>
        <ul
          className="dark-list"
          style={{
            maxHeight: "calc(96vh - 241px)",
            overflowY: "auto",
            marginTop: 10,
            padding: "0px 10px",
          }}
        >
          {!unlocked ? (
            questionItems
              .filter(
                (ia) =>
                  !ia.tag ||
                  (ia.tag &&
                    !questionTagList.find((qt) => (ia.tag.includes(":") ? ia.tag.split(":").includes(qt) : qt == ia.tag)) &&
                    ia.questionLanguage !== undefined &&
                    ia.questionLanguage
                      .find((l) => l.languageCode === props.lang)
                      .label.toString()
                      .toLowerCase()
                      .includes(filter.toLowerCase()))
              )
              .map((q, i) => {
                let qLang = q.questionLanguage.find((ql) => ql.languageCode == props.lang);
                return (
                  <ListItem
                    style={{
                      listStyle: "none",
                      display: "flex",
                      margin: 0,
                      padding: 5,
                      background: selectedQuestion && selectedQuestion.questionId === q.questionId ? "#2f2f2f" : undefined,
                    }}
                    key={i}
                    onClick={() => toggleQuestionInfo(selectedQuestion && selectedQuestion.questionId === q.questionId ? null : q)}
                  >
                    <ListItemAvatar className="">{renderTypeIcon(q.type)}</ListItemAvatar>
                    <ListItemText style={{ maxWidth: "65%", color: "#fff" }} primary={qLang ? qLang.label : "NoLabel"} />
                    <ListItemSecondaryAction>
                      <IconButton
                        className="icon-btn-dark-s"
                        edge="end"
                        style={{
                          padding: "8px",
                          marginLeft: 0,
                          color: activeQuestions.find((aq) => aq == q.questionId) !== undefined ? "#fff" : "#ffffff99",
                          backgroundColor: activeQuestions.find((aq) => aq == q.questionId) !== undefined ? "#20a8d8e0" : undefined,
                        }}
                        onClick={() => deployQuestionToClients(q.questionId)}
                      >
                        <Tooltip title={<SystemLabel name="DeployToRoomTooltip" />}>
                          <MeetingRoomIcon />
                        </Tooltip>
                      </IconButton>
                      <Tooltip title={<SystemLabel name="DeployToPresenterTooltip" />}>
                        <span>
                          <IconButton
                            style={{
                              padding: "8px",
                              marginLeft: 20,
                              color: activePresenterQuestion == q.questionId ? "#fff" : "#ffffff99",
                              backgroundColor: activePresenterQuestion == q.questionId ? "#20a8d8e0" : undefined,
                            }}
                            onClick={() => {
                              setQuestionDeployLoadingId(q.questionId);
                              deployQuestionToPresenter(q.questionId);
                            }}
                            edge="end"
                          >
                            {questionDeployLoadingId === q.questionId ? (
                              <span style={{ height: 24, width:24 }}>
                                <SmallLoader />
                              </span>
                            ) : (
                              <BarChartIcon />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                    </ListItemSecondaryAction>
                  </ListItem>
                  /*  </Card> */
                );
              })
          ) : (
            <ReactDragList
              animation={10}
              dataSource={questionItems.filter(
                (ia) =>
                  ia.questionLanguage !== undefined &&
                  ia.questionLanguage
                    .find((l) => l.languageCode === props.lang)
                    .label.toString()
                    .toLowerCase()
                    .includes(filter.toLowerCase())
              )}
              rowKey={"questionId"}
              className="simple-drag"
              rowClassName="simple-drag-row"
              handles={true}
              onUpdate={(event, dataSource) => handleOrderChange(event, dataSource)}
              row={(q, index) => {
                let qLang = q.questionLanguage.find((ql) => ql.languageCode == props.lang);
                return (
                  <div
                    style={{
                      listStyle: "none",
                      width: "100%",
                    }}
                  >
                    <ListItem
                      className="dark-card"
                      style={{
                        listStyle: "none",
                        display: "flex",
                        margin: 0,
                        padding: 10,
                        background: selectedQuestion && selectedQuestion && selectedQuestion.questionId === q.questionId ? "#2f2f2f" : undefined,
                      }}
                      key={index}
                      onClick={() => toggleQuestionInfo(selectedQuestion && selectedQuestion.questionId === q.questionId ? null : q)}
                    >
                      <ListItemAvatar className="">{renderTypeIcon(q.type)}</ListItemAvatar>

                      <ListItemText style={{ maxWidth: "65%", color: "#fff" }} primary={qLang ? qLang.label : "NoLabel"} />
                      <ListItemSecondaryAction>
                        <IconButton
                          className="icon-btn-dark-s"
                          edge="end"
                          style={{
                            padding: "8px",
                            marginLeft: 0,
                            color: activeQuestions.find((aq) => aq == q.questionId) !== undefined ? "#fff" : "#ffffff99",
                            backgroundColor: activeQuestions.find((aq) => aq == q.questionId) !== undefined ? "#20a8d8e0" : undefined,
                          }}
                          onClick={() => deployQuestionToClients(q.questionId)}
                        >
                          <Tooltip title={<SystemLabel name="DeployToRoomTooltip" />}>
                            <MeetingRoomIcon />
                          </Tooltip>
                        </IconButton>

                        <IconButton
                          disabled={!q.presenterType || q.presenterType === "NONE"}
                          style={{
                            padding: "8px",
                            marginLeft: 20,
                            color: activePresenterQuestion == q.questionId ? "#fff" : "#ffffff99",
                            backgroundColor: activePresenterQuestion == q.questionId ? "#20a8d8e0" : undefined,
                          }}
                          onClick={() => deployQuestionToPresenter(q.questionId)}
                          edge="end"
                        >
                          <Tooltip title={!q.presenterType || q.presenterType === "NONE" ? <SystemLabel name="NoPresenterTypeTooltip" /> : <SystemLabel name="DeployToPresenterTooltip" />}>
                            <BarChartIcon />
                          </Tooltip>
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </div>
                );
              }}
            />
          )}
        </ul>
        {modalOpen ? <QuestionModal sortOrder={getMaxSortOrder()} open={modalOpen} toggleModal={toggleModal} {...props} /> : null}
      </div>
    );
  };
  return <div>{renderQuestionList()}</div>;
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(QuestionList);
